import { Component, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/_helpers/alert.service';
import { ComboBookingManagment } from 'src/app/_services/combo_booking';
import { RoutingService } from 'src/app/_services/routing.service';
import { ServiceManagment } from 'src/app/_services/service_managment';
import { StorageService } from 'src/app/_services/storage.service';

@Component({
  selector: 'app-reason-declined',
  templateUrl: './reason-declined.component.html',
  styleUrls: ['./reason-declined.component.scss'],
})
export class ReasonDeclinedComponent implements OnInit {
  openOne: boolean = false;
  openTwo: boolean = false;
  openThree: boolean = false;
  openFour: boolean = false;
  openFormTwo: boolean = false;
  declineReason: any;
  @ViewChild('addUpdateNgForm') addUpdateNgForm!: NgForm;
  addUpdateForm: FormGroup;
  bookingId: any;
  comboBookingId: any;
  tempServiceInfo: any;
  constructor(
    public dialogRef: MatDialogRef<ReasonDeclinedComponent>,
    private ngZone: NgZone,
    public routing: RoutingService,
    private alertService: AlertService,
    private _formBuilder: FormBuilder,
    public storage: StorageService,
    private serviceManagment: ServiceManagment,
    private activatedRoute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any,

    private comboBookingManagment: ComboBookingManagment
  ) {
    this.addUpdateForm = this._formBuilder.group({
      reason: ['', []],
    });
  }

  async ngOnInit() {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      this.bookingId =
        this.activatedRoute.snapshot.queryParamMap.get('bookingId');
      this.comboBookingId =
        this.activatedRoute.snapshot.queryParamMap.get('comboBookingId');
    });
  }

  closeDialog() {
    this.ngZone.run(() => {
      this.dialogRef.close('no');
    });
  }

  OpenSignUpForm() {
    this.ngZone.run(() => {
      this.dialogRef.close('yes');
    });
  }

  valueChangedOne() {
    this.openTwo = false;
    this.openThree = false;
    this.openFour = false;
    this.openOne = !this.openOne;
    if (this.openOne) {
      this.declineReason = 'Weather';
    }
  }

  valueChangedTwo() {
    this.openOne = false;
    this.openThree = false;
    this.openFour = false;
    this.openTwo = !this.openTwo;
    if (this.openTwo) {
      this.declineReason = 'internal maintenance';
    }
  }

  valueChangedThree() {
    this.openOne = false;
    this.openTwo = false;
    this.openFour = false;
    this.openThree = !this.openThree;
    if (this.openThree) {
      this.declineReason = 'safety concerns';
    }
  }

  valueChangedFour() {
    this.openOne = false;
    this.openTwo = false;
    this.openThree = false;
    this.openFour = !this.openFour;
  }

  /** The reason that is selected now: one of the three, or the text written under Other. Empty when there is none. */
  private chosenReason(): string {
    if (this.openFour) return String(this.addUpdateForm.value.reason || '').trim();
    if (this.openOne) return 'Weather';
    if (this.openTwo) return 'internal maintenance';
    if (this.openThree) return 'safety concerns';
    return '';
  }

  async onSubmitForm() {
    if (this.addUpdateForm.valid) {
      // A booking is never declined without a reason: the customer, or the
      // partner of a partner booking, is shown it. (A choice clicked off, or
      // text left under Other after choosing another reason, used to count.)
      const reason = this.chosenReason();
      if (!reason) {
        this.alertService.show_alert('Choose a reason, or choose Other and write one.', '', 'error');
        return;
      }
      this.declineReason = reason;
      const formData: any = {
        status: 'declined',
        declineReason: this.declineReason,
      };
      if (this.data.listingseiaya) {
        await this.serviceManagment
          .updateBooking(this.data.bookingId, formData)
          .subscribe({
            next: (response: any) => {
              if (response && response.isSuccess) {
                this.tempServiceInfo = response.data;
                this.alertService.show_alert(response.message);
                this.openFormTwo = true;
              }
            },
            error: (errorResponse: any) => {
              this.alertService.show_alert(
                'Something went Wrong!',
                '',
                'error'
              );
            },
          });
      }
      if (this.data.detailseiaya) {
        await this.serviceManagment
          .updateBooking(this.bookingId, formData)
          .subscribe({
            next: (response: any) => {
              if (response && response.isSuccess) {
                this.tempServiceInfo = response.data;
                this.alertService.show_alert(response.message);
                this.openFormTwo = true;
              }
            },
            error: (errorResponse: any) => {
              this.alertService.show_alert(
                'Something went Wrong!',
                '',
                'error'
              );
            },
          });
      }
      if (this.data.combolistingseiaya) {
        await this.comboBookingManagment
          .updateComboBookingManagment(this.data.bookingId, formData)
          .subscribe({
            next: (response: any) => {
              if (response && response.isSuccess) {
                this.tempServiceInfo = response.data;
                this.alertService.show_alert(response.message);
                this.openFormTwo = true;
              }
            },
            error: (errorResponse: any) => {
              this.alertService.show_alert(
                'Something went Wrong!',
                '',
                'error'
              );
            },
          });
      }
      if (this.data.combodetailseiaya) {
        await this.comboBookingManagment
          .updateComboBookingManagment(this.comboBookingId, formData)
          .subscribe({
            next: (response: any) => {
              if (response && response.isSuccess) {
                this.tempServiceInfo = response.data;
                this.alertService.show_alert(response.message);
                this.openFormTwo = true;
              }
            },
            error: (errorResponse: any) => {
              this.alertService.show_alert(
                'Something went Wrong!',
                '',
                'error'
              );
            },
          });
      }
    } else {
      this.alertService.show_alert(
        'Please fill all the mandatory fields!',
        '',
        'error'
      );
    }
  }

  async closeForm() {
    this.ngZone.run(() => {
      this.dialogRef.close('no');
    });
  }

  async updateForm() {
    const formData: any = {
      isActive: false,
    };
    await this.serviceManagment
      .updateService(this.tempServiceInfo.service.id, formData)
      .subscribe({
        next: (response: any) => {
          if (response && response.isSuccess) {
            this.ngZone.run(() => {
              this.dialogRef.close('yes');
            });
          }
        },
        error: (errorResponse: any) => {
          this.alertService.show_alert('Something went Wrong!', '', 'error');
        },
      });
  }
}
